import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./base-query";

const refundAPI = createApi({
    reducerPath: "refundAPI",
    baseQuery,
    tagTypes: ["refund"],
    endpoints: (builder) => ({
        getRefundDetails: builder.mutation({
            query: ({ page = 0, limit = 10, startDate, endDate }) => {
                let apiUrl = `revenue/refunds?page=${page + 1}&limit=${limit}`;

                if (startDate && endDate) {
                    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["refund"],
        }),
        getVendorPaymentLogs: builder.query({
            query: ({page, size, startDate, endDate}) => {
                let apiUrl = `revenue/vendor-payments?page=${page + 1}&size=${size}`;

                if (startDate && endDate) {
                    apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
                }

                return {
                    url: apiUrl,
                    method: 'GET'
                };
            },
            transformResponse: (response) => response
        }),
        getVendorTours: builder.mutation({
            query: ({ vendorId, page = 0, limit = 10, startDate, endDate }) => {
                let apiUrl = `revenue/vendor-payments/tours?vendorId=${vendorId}&page=${page + 1}&limit=${limit}`;

                if (startDate && endDate) {
                apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
                }

                return {
                url: apiUrl,
                method: 'GET',
                };
            },
            transformResponse: (response) => response,
        }),
    }),
});

export const {
    useGetRefundDetailsMutation,
    useGetVendorPaymentLogsQuery,
    useGetVendorToursMutation
} = refundAPI;

export default refundAPI;